import axios from 'axios'
import { createTransactionID, getUTCTime } from '../utils'

const win: any = window;

let config = {
  api: {
    baseURL: '',
    headers: {
      'Content-Type': 'application/json',
      Authorization: '',
      'x-api-key': '',
      'X-Correlation-Id': '',
      'X-Source-Channel': 'PORTAL',
      'X-Transaction-Id': '',
    },
  },
}

export const api = axios.create({ ...config.api })

api.interceptors.request.use(
  async (conf: any) => {

    conf.baseURL = win['apigee_bm_base_url']
    conf.headers.Authorization = `Bearer ${win['bmToken']}`
    conf.headers['x-api-key'] = win['cem_key']
    conf.headers['X-Transaction-Id'] = createTransactionID()
    conf.headers['X-Correlation-Id'] = createTransactionID(true)
    conf.headers['X-Timestamp'] = getUTCTime();
    return conf
  },
  (err: any) => {
    console.log('error in getting ', err)
  }
)

api.interceptors.response.use(
  async (response: any) => {
    return response;
  },
  async (error: any) => {
    if (error?.response) {
      return error?.response;
    } else {
      return error
    }
  }
);

const graphqlApi = () => {
  const packageName = 'roaming'
  const query = `{
    getCategoryByID(id: "`+ packageName + `") {
      id
      subCategories {
        id
        name
      }
      metaExtension {
        dataSet {
            name
            genericData {
                schemaRef
                valueSet
            }
        }
      }
    }
  }`

  return api.post('/catalog-agg-query/graphql', { query: query });
}

export {
  graphqlApi
};
